import React, { ReactNode } from 'react';
import { Layout, theme } from 'antd';

const { Content } = Layout;

interface ContentLayoutProps {
  children: ReactNode;
  compact?: boolean;
}

const ContentLayout: React.FC<ContentLayoutProps> = ({ children, compact = false }) => {
  const {
    token: { borderRadiusLG },
  } = theme.useToken();

  return (
    <Content
      style={{
        margin: compact ? 0 : '24px 16px',
        // padding: "0px",
        background: 'none',
        borderRadius: borderRadiusLG,
      }}>
      {children}
    </Content>
  );
};

export default ContentLayout;
